<div class="flex flex-col h-full">
  <app-navigation></app-navigation>
  <main class="grow">
    <router-outlet ></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
